function initMembershipFloatingWidget() {
  var widgets = document.querySelector('.membership-floating-widget');
  if (!widgets) return;

  var closeButton = widgets.querySelector('.membership-floating-widget__close');
  if (!closeButton) return;

  closeButton.addEventListener('click', function () {
    widgets.classList.add('membership-floating-widget--hidden');
  });

  setTimeout(() => {
    if (widgets) {
      widgets.classList.remove('membership-floating-widget--hidden');
    }
  }, 7000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMembershipFloatingWidget);
} else {
  initMembershipFloatingWidget();
}